import { ArrowUpRight, Check } from "lucide-react";
import { ASSETS } from "../lib/constants";

const products = [
  {
    id: "privacy",
    badge: "Launch product",
    badgeColor: "#00E5FF",
    featured: true,
    title: "Privacy Smart Film",
    subtitle: "Van inkijk naar privacy met één klik.",
    text: "Onze slimme privacyfilm maakt glas direct transparant of mat. Ideaal voor badkamers, kantoren, praktijkruimtes, glaswanden en moderne woningen.",
    bullets: [
      "Instant privacy",
      "Licht blijft binnen",
      "Geen gordijnen nodig",
      "Strakke moderne afwerking",
    ],
    cta: "Ontdek privacyfilm",
    image: ASSETS.privacy,
    extraNote: null,
  },
  {
    id: "led",
    badge: "B2B",
    badgeColor: "#C5A059",
    featured: false,
    title: "LED / Display Film",
    subtitle: "Maak van glas een digitale eyecatcher.",
    text: "Transformeer ramen in displayruimte voor branding, reclame en visuele impact. Perfect voor showrooms, winkels, horeca en kantoren.",
    bullets: [
      "Extra zichtbaarheid",
      "Reclame via glas",
      "Premium uitstraling",
      "Ideaal voor commerciële ruimtes",
    ],
    cta: "Vraag B2B-info aan",
    image: ASSETS.led,
    extraNote: "Prijs op aanvraag voor B2B-projecten.",
  },
  {
    id: "panels",
    badge: "Interieur",
    badgeColor: "#FFFFFF",
    featured: false,
    title: "Smart Wall Panels",
    subtitle: "Van muur naar design statement.",
    text: "Designpanelen met marble, stone, concrete en premium looks voor snelle interieurtransformaties.",
    bullets: [
      "High-end afwerking",
      "Snelle make-over",
      "Voor woningen en bedrijven",
      "Combineerbaar met licht en displays",
    ],
    cta: "Ontdek smart walls",
    image: ASSETS.panels,
    extraNote: null,
  },
];

export default function Products() {
  const scrollToForm = () => {
    const el = document.getElementById("lead-form");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="producten"
      className="relative py-24 md:py-32"
      data-testid="products-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400 mb-4">
            Onze oplossingen
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light text-white tracking-tight">
            Drie manieren om een oppervlak{" "}
            <span className="italic" style={{ color: "#C5A059" }}>
              slim
            </span>{" "}
            te maken.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {products.map((p) => (
            <article
              key={p.id}
              id={p.id}
              className={`jn-glass jn-card-hover rounded-3xl overflow-hidden flex flex-col relative ${
                p.featured ? "lg:scale-[1.02]" : ""
              }`}
              style={
                p.featured
                  ? {
                      boxShadow: "0 0 40px rgba(0,229,255,0.12)",
                      borderColor: "rgba(0,229,255,0.3)",
                    }
                  : {}
              }
              data-testid={`product-card-${p.id}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover"
                />
                <div
                  className="absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(180deg, transparent 40%, rgba(10,10,10,0.85) 100%)",
                  }}
                />
                <div
                  className="absolute top-4 left-4 text-[10px] font-bold uppercase tracking-[0.22em] px-2.5 py-1 rounded-full"
                  style={{
                    color: p.badgeColor,
                    border: `1px solid ${p.badgeColor}55`,
                    background: "rgba(0,0,0,0.5)",
                  }}
                >
                  {p.badge}
                </div>
              </div>

              <div className="p-7 md:p-8 flex flex-col gap-5 flex-1">
                <div>
                  <h3 className="font-heading text-2xl md:text-3xl text-white font-medium tracking-tight">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-sm text-zinc-400 font-body">
                    {p.subtitle}
                  </p>
                </div>
                <p className="text-sm text-zinc-400 font-body leading-relaxed">
                  {p.text}
                </p>
                <ul className="space-y-2 mt-1">
                  {p.bullets.map((b) => (
                    <li
                      key={b}
                      className="flex items-start gap-2.5 text-sm text-zinc-200 font-body"
                    >
                      <Check
                        size={16}
                        className="mt-0.5 shrink-0 text-cyan-400"
                      />
                      {b}
                    </li>
                  ))}
                </ul>

                {p.extraNote && (
                  <div
                    className="text-[11px] uppercase tracking-[0.18em] font-body px-3 py-2 rounded-lg border"
                    style={{
                      color: p.badgeColor,
                      borderColor: `${p.badgeColor}40`,
                      background: `${p.badgeColor}0d`,
                    }}
                  >
                    {p.extraNote}
                  </div>
                )}

                <button
                  onClick={scrollToForm}
                  className="group mt-auto inline-flex items-center gap-2 text-sm text-white hover:text-cyan-400 transition font-medium"
                  data-testid={`product-cta-${p.id}`}
                >
                  {p.cta}
                  <ArrowUpRight
                    size={16}
                    className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                  />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
